import {BottomSheetElement} from '@/common/ui/BottoSheetElement';

export default class BottomSheetDisplayer {
    bottomSheetSelector: string | undefined;
    el: HTMLElement;
    closestParentSelector: string;

    constructor(bottomSheetSelector: string | undefined, el: HTMLElement, closestParentSelector: string) {
        this.bottomSheetSelector = bottomSheetSelector;
        this.el = el;
        this.closestParentSelector = closestParentSelector;
    }

    async openBottomSheet(): Promise<void> {
        if (this.bottomSheetSelector) {
            const parentElement = this.el.closest(this.closestParentSelector);
            const item = parentElement!.querySelector(this.bottomSheetSelector);
            await (item as BottomSheetElement)!.openBottomSheet();
        }
    }
}
